var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewMag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_303",
    "data-name": "Group 303",
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 25,
    viewBox: "0 0 37 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_744",
    "data-name": "Rectangle 744",
    transform: "translate(0 4)",
    fill: "rgba(255,255,255,0)",
    stroke: "var(--border-color)",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 21,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 31.5,
    height: 19.5,
    rx: 2.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_747",
    "data-name": "Rectangle 747",
    width: 10,
    height: 10,
    transform: "translate(27)",
    fill: "var(--theme-sec-bg)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_72",
    "data-name": "Line 72",
    y2: 11,
    transform: "translate(9 9)",
    fill: "none",
    stroke: "var(--border-color)",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_73",
    "data-name": "Line 73",
    y2: 11,
    transform: "translate(14 9)",
    fill: "none",
    stroke: "var(--border-color)",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_74",
    "data-name": "Line 74",
    y2: 11,
    transform: "translate(19 9)",
    fill: "none",
    stroke: "var(--border-color)",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_75",
    "data-name": "Line 75",
    y2: 11,
    transform: "translate(24 9)",
    fill: "none",
    stroke: "var(--border-color)",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302",
    transform: "translate(29.565 1.945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M62.154,73.812h-5.4",
    transform: "translate(-56.75 -71.106)",
    fill: "none",
    stroke: "var(--border-color)",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727-2",
    "data-name": "Path 727",
    d: "M5.4,0H0",
    transform: "translate(2.702) rotate(90)",
    fill: "none",
    stroke: "var(--border-color)",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMag);
export default __webpack_public_path__ + "static/media/newMag.56a786ef4cc2ad4f8a9c4871e4f7a496.svg";
export { ForwardRef as ReactComponent };